import { Routes, Route } from "react-router-dom";

import "./App.css";

import Navbar from "./components/Navbar";
import WhatsAppButton from "./components/WhatsAppButton";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import OrderView from "./pages/OrderView";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Baby from "./pages/Baby";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Favorites from "./pages/Favorites";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import Accessoires from "./pages/Accessoires";

import Admin from "./pages/Admin";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";


function App() {

  return (

    <>

      <ScrollToTop />

      <Navbar />


      <Routes>


        {/* HOME */}

        <Route
          path="/"
          element={<Home />}
        />


        {/* SHOP */}

        <Route
          path="/shop"
          element={<Shop />}
        />


        {/* BABY MAIN */}

        <Route
          path="/category/Baby"
          element={<Baby />}
        />


        {/* BABY ACCESSORIES PAGE */}

        <Route
          path="/category/Baby/Accessories"
          element={<Accessoires />}
        />


        {/* ALL MAIN CATEGORIES */}

        <Route
          path="/category/:name"
          element={<Products />}
        />


        {/* BABY SUBCATEGORIES */}

        <Route
          path="/category/:name/:subCategory"
          element={<Products />}
        />


        {/* BABY ACCESSORIES TYPES */}

        <Route
          path="/category/:name/:subCategory/:accessory"
          element={<Products />}
        />


        {/* ORDER */}

        <Route
          path="/order/:id"
          element={<OrderView />}
        />


        {/* PRODUCT */}

        <Route
          path="/product/:id"
          element={<ProductDetails />}
        />


        {/* CART */}

        <Route
          path="/cart"
          element={<Cart />}
        />


        {/* CHECKOUT */}

        <Route
          path="/checkout"
          element={<Checkout />}
        />


        {/* FAVORITES */}

        <Route
          path="/favorites"
          element={<Favorites />}
        />


        {/* CONTACT */}

        <Route
          path="/contact"
          element={<Contact />}
        />


        {/* ADMIN LOGIN */}

        <Route
          path="/admin-login"
          element={<AdminLogin />}
        />


        {/* ADMIN */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />


        {/* DASHBOARD */}

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />


        {/* ORDERS */}

        <Route
          path="/admin/orders"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />


      </Routes>


      <WhatsAppButton />

      <Footer />

    </>

  );

}


export default App;